import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-028f94f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resume-list-container" }
const _hoisted_2 = { class: "resume-grid" }
const _hoisted_3 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading resumes...", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "display-1 text-muted bi bi-file-post" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mt-3" }, "No Resumes Found", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Create a new resume to get started", -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "resume-preview" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "resume-info" }
const _hoisted_16 = { class: "resume-name" }
const _hoisted_17 = { class: "resume-date" }


import { format } from "date-fns";

interface ResumeListItem {
  id: string;
  name: string;
  lastModified: Date;
  previewUrl?: string | null;
  template?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ResumeList',
  props: {
    resumes: {},
    loading: { type: Boolean },
    templates: {}
  },
  emits: ["select"],
  setup(__props: any) {

const props = __props;



function getPreviewImage(resume: ResumeListItem) {
  if (resume.previewUrl) {
    return resume.previewUrl;
  }
  // Fallback to template preview image
  return props.templates[0]?.previewImage || "";
}

function formatDate(date: Date | undefined | null): string {
  if (!date) return "";
  return format(new Date(date), "MMM d, yyyy");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
        : (_ctx.resumes.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_11))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.resumes, (resume) => {
              return (_openBlock(), _createElementBlock("div", {
                key: resume.id,
                class: "resume-card",
                onClick: ($event: any) => (_ctx.$emit('select', resume.id))
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("img", {
                    src: getPreviewImage(resume),
                    alt: resume.name
                  }, null, 8, _hoisted_14)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("h5", _hoisted_16, _toDisplayString(resume.name), 1),
                  _createElementVNode("p", _hoisted_17, "Last modified: " + _toDisplayString(formatDate(resume.lastModified)), 1)
                ])
              ], 8, _hoisted_12))
            }), 128))
    ])
  ]))
}
}

})